"use strict";
/* eslint-disable complexity */
/* eslint-disable no-console */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbCCDevAuthenticator = void 0;
const framework_1 = require("../../../framework");
const types_1 = require("../../../features/session/cc/types");
//TODO Authenticator only for model or not??
class MbCCDevAuthenticator extends framework_1.BaseAuthenticator {
    constructor(session, xhr, helper, urlConfig) {
        super(session);
        this.agentToken = '';
        this.agentRefreshToken = '';
        this.doLogin = (data) => __awaiter(this, void 0, void 0, function* () {
            const loginResult = yield this.helper.requestLogin(data);
            return Object.assign(Object.assign({}, loginResult), { agentToken: this.agentToken, agentRefreshToken: this.agentRefreshToken, username: data.username, entrypoint: types_1.EntrypointType.CCDev });
        });
        this.doLogout = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const accessToken = (_a = this.getSession().getData()) === null || _a === void 0 ? void 0 : _a.accessToken;
            yield this.xhr.POST(this.urlConfig.logout, { accessToken });
        });
        this.requestAgentData = (params) => __awaiter(this, void 0, void 0, function* () {
            const data = yield this.helper.requestAgentData(params);
            this.agentToken = data.accessToken;
            this.agentRefreshToken = data.refreshToken;
            return data;
        });
        this.requestInteractionId = (param) => {
            return this.helper.requestInteractionId(param);
        };
        this.requestPasswordPosition = (param) => {
            return this.helper.requestPasswordPosition(param);
        };
        this.xhr = xhr;
        this.helper = helper;
        this.urlConfig = urlConfig;
    }
}
exports.MbCCDevAuthenticator = MbCCDevAuthenticator;
//# sourceMappingURL=index.js.map